import { atom } from "recoil"

export const templateContactsRequestIdState = atom({
  key: "atoms/contact/templateContactsRequestIdState",
  default: 0,
})
